import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useColorWheel from "@/hooks/useColorWheel";
import { onMounted, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Array || null,
    default: () => null,
  },
  start: {
    type: Number,
    default: () => 0,
  },
},
  setup(__props) {

const props = __props



const answerRef = ref();
const chartInfo = ref();
const { createWheelCard } = useColorWheel();

watch(
  () => props.list,
  (newList) => {
    const startItem = props.start;
    const list = newList.map((i: any) => ({ ...i, value: 1 }));
    let i = 1;
    while (i < startItem) {
      const tmp = list.shift();
      list.push(tmp);
      i++;
    }
    chartInfo.value.changeData(list);
    chartInfo.value.getElements().forEach((elm: any) => {
      elm.setState("selected", true);
    });
  }
);

onMounted(() => {
  const list = props.list;
  // 根据start_item 进行旋转
  const startItem = props.start;

  let i = 1;
  while (i < startItem) {
    const tmp = list.shift();
    list.push(tmp);
    i++;
  }
  const chart = createWheelCard({
    elmRef: answerRef.value,
    list: list,
    createConfig: {},
  });
  chart.render();
  chart.getElements().forEach((elm: any) => {
    elm.setState("selected", true);
  });
  chartInfo.value = chart;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "answerRef",
    ref: answerRef
  }, null, 512))
}
}

})